Vue.component('unlockQueue', {
  template: templates.unlockQueue,
  data() {
    return {
      model: {
        unlocks: {},
        packs: {},
        hasResults: false,
        isLoading: false
      },
      cancelTokenSource: null
    }
  },
  mounted() {
    const c = this;
    c.$root.$on('packGiven', () => {
      c.get();
    })
    
    c.get();
    c.getPacks();
    c.connect();
  },
  beforeDestroy() {
    const c = this;

    if (c.ws) {
      c.ws.close();
    }
    
    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {

        const messageData = event.data;

        try {

          const parsedData = JSON.parse(messageData);
          if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.message === 'pack_given'){
            c.get();
          }

        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
    
      const c = this;
      let data = {};
      let getUsers = false;

      // if (c.cancelTokenSource) {
      //   c.cancelTokenSource.cancel('Previous request canceled.');
      // }

      c.cancelTokenSource = axios.CancelToken.source();
 
      unlockQueueService.getQueue({cancelToken: c.cancelTokenSource.token})
        .then(function (response) {
          // Check if response has data
          if (!response.data || response.data.length === 0) {
            c.model.hasResults = false;
            c.model.isLoading = true; // Stop loading
            c.model.unlocks = {};
            return;
          }
         
          c.model.hasResults = true;
          for (let d of response.data) {
            d.disabled = false;
            data[`${d.id}`] = d;

            if (d.twitchDisplayName == null) {
              getUsers = true;
            }
          }

          if (getUsers) {

            twitchAPI.getUsersById(data, function(userData) {

              for (let d of userData) {
                for (let i in data) {
                  if (data[`${i}`].twitchId == d.id) {
                    data[`${i}`].twitchDisplayName = d.display_name;
                    data[`${i}`].open = false;
                  }
                }
              }
              c.model.unlocks = data;
              c.model.isLoading = true; // Stop loading after async operation completes

            });

          } else {
            c.model.unlocks = data;
            c.model.isLoading = true; // Stop loading
          }
          console.log(c.model)
        })
        .catch(function (error) {
          c.model.hasResults = false;
          c.model.isLoading = true; // Stop loading on error
          c.model.unlocks = {};
        });
    },
    getPacks() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    open(id) {
      const c = this;
      c.save(id);
    },
    save(id) {
      const c = this;

      c.model.unlocks[`${id}`].disabled = true;

      unlockQueueService.save({id: id})
        .then(function (response) {
          c.model.unlocks[`${id}`].active = false;
          let data = {
            channelId: utils.cookies.get('channelId'),
            message: 'pack_given',
            status: 'give_pack'
          }
          c.ws.send(JSON.stringify(data));
        })
        .catch(function (error) {
          //console.log(error);
        });
    }, 
    cancel(id) {
      const c = this;

      var result = confirm("Are you sure you want to remove this pack from the queue?");
      if (result == true) {
        console.log( c.model.unlocks[`${id}`]);
        unlockQueueService.cancel({id: id, twitchId: c.model.unlocks[`${id}`].twitchId})
          .then(function (response) {
            c.model.unlocks[`${id}`].active = false;
            c.$root.$emit('CancelledPack');

            const data = {
              targetConnectionId: response.data.twitchDisplayName[0].connectionId,
              twitchId: response.data.twitchDisplayName[0].twitchId,
              channelId: utils.cookies.get('channelId'),
              message: 'pack_given',
            }

            if(data.targetConnectionId != null || data.targetConnectionId != 0){
              data.status = 'give_pack';
          
            }

            c.ws.send(JSON.stringify(data));

          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    },
    sendToHq(id,twitchId){
      const c = this;

      unlockQueueService.sendToHQ({id: id})
      .then(function (response) {
        c.model.unlocks[`${id}`].hq = true;
        let data = {
          channelId: utils.cookies.get('channelId'),
          twitchId: twitchId,
          message: 'pack_given',
        }
        c.get();
        c.ws.send(JSON.stringify(data));
        
      })
      .catch(function (error) {
        //console.log(error);
      });
    }
  }
});